<template>
  <div>
    <com-search :columns="searchColumn" @search="handleSearch">
      <el-button type="primary" @click="handleExport">导出</el-button>
    </com-search>
    <com-card class="mt-15px">
      <com-table ref="table" :api="api" :columns="columns">
        <template #created="{ data }">
          {{ data.createTime | timeFormate }}
        </template>
      </com-table>
    </com-card>
  </div>
</template>

<script>
import { exportExcel } from '@/utils'
import { userWithdraw } from '@/api/order'
import { timeFormate } from '@/filters'

export default {
  data() {
    return {
      api: userWithdraw,
      searchColumn: [
        {
          label: '用户ID/手机号',
          prop: 'userCondition',
          type: 'input'
        },
        {
          label: '订单编号',
          prop: 'number',
          type: 'input'
        },
        {
          label: '网点',
          prop: 'refUserRegisterStoreName',
          type: 'input'
        },
        {
          label: '时间范围',
          prop: 'date',
          type: 'date'
        }
      ],
      columns: [
        {
          label: '订单编号',
          prop: 'number'
        },
        {
          label: '用户ID',
          prop: 'refUserNumber'
        },
        {
          label: '手机号',
          prop: 'refUserPhone'
        },
        {
          label: '用户选择网点',
          prop: 'refUserRegisterStoreName'
        },
        {
          label: '提现充值金',
          prop: 'amount'
        },
        {
          label: '提现赠送金',
          prop: 'giveAmount'
        },
        {
          label: '提现原因',
          prop: 'remark'
        },
        {
          label: '提现时间',
          prop: 'created',
          type: 'slot',
          slotName: 'created'
        }
      ],
      query: {}
    }
  },
  methods: {
    handleSearch(val) {
      this.query = val
      this.$refs.table.search(val)
    },
    async handleExport() {
      try {
        this.$message.info('正在导出请稍后')
        const query = {
          ...this.query,
          pageIndex: 1,
          pageSize: 10000
        }
        const {
          data: { records }
        } = await userWithdraw(query)
        console.log('data :>> ', records)
        const newArr = []
        records.forEach((item) => {
          const param = {
            订单编号: item.number,
            用户ID: item.refUserNumber,
            手机号: item.refUserPhone,
            用户选择网点: item.refUserRegisterStoreName,
            提现充值金: item.amount,
            提现赠送金: item.giveAmount,
            提现原因: item.remark,
            提现时间: timeFormate(item.createTime)
          }
          newArr.push(param)
        })
        exportExcel(newArr, '用户提现订单')
      } catch (err) {
        console.log('err :>> ', err)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
